import { Heading } from "@tokenterminal/core/ui/heading/Heading"
import { useIsMobile } from "@tokenterminal/ui/hooks/isMobile"
import { useIsMac } from "hooks/useIsMac"
import { V3Layout } from "layouts/v3"
import Link from "next/link"
import ErrorIcon from "@/icons/error.svg"

export default function FourOhFour() {
  const isMobile = useIsMobile()
  const isMac = useIsMac()

  return (
    <div className="flex flex-col gap-6 text-center items-center justify-center m-auto h-full py-8">
      <ErrorIcon role="img" />
      <div className="flex flex-col gap-2">
        <Heading as="h1" level={2} className="mx-auto">
          404 - Page not found
        </Heading>
        {isMobile ? (
          <p className="text-fg-secondary whitespace-break-spaces text-sm">
            Try out the search at the top or
            <br />
            head over to our{" "}
            <Link href="/" className="underline">
              Homepage
            </Link>
          </p>
        ) : (
          <p className="text-fg-secondary whitespace-break-spaces text-sm">
            Try hitting {isMac ? "cmd+k" : "ctrl+k"} or
            <br />
            head over to our{" "}
            <Link href="/" className="underline">
              Homepage
            </Link>
          </p>
        )}
      </div>
    </div>
  )
}

FourOhFour.getLayout = V3Layout

export const getStaticProps = async () => {
  return {
    props: {},
  }
}
